import Vue from 'vue';
import App from './app.vue';
import router from './router';
// import store from './store';
import VueHead from 'vue-head';
import { HttpError, ValidationError, SessionInvalidError } from './errors';

Vue.config.productionTip = false;

import DefaultLayout from '@/templates/default.vue';
import BootstrapVue from 'bootstrap-vue';

// 今は気にするレベルではないがスレッドセーフじゃないことに注意。
let openingAlert = false;

const handleError = (error: Error): void => {

  const enableOpenAlert =  !openingAlert;
  openingAlert = true;

  if (error instanceof HttpError) {
    console.error(error);
    if (enableOpenAlert) alert('通信エラーが発生しました。画面を再読み込みしてください。');
  } else {
    console.error(error);
    if (enableOpenAlert) alert('予期しないエラーが発生しました。画面を再読み込みしてください。');
  }

  window.setTimeout(() => { openingAlert = false; }, 100);

};

Vue.use(BootstrapVue);
Vue.use(VueHead);
Vue.component('default-layout', DefaultLayout);

Vue.config.errorHandler = (error, vm, info) => {
  handleError(error);
};

const vue = new Vue({
  router,
  // store,
  render: (h) => h(App),
}).$mount('#app');

window.addEventListener('unhandledrejection', (event) => {
  handleError(event.reason);
});
